module.exports = __webpack_public_path__ + "img/Logo2019.6e77782f.png";